import Gallery from "webPage/Gallery";
import Track from "webPage/Track";

export default function handleBlogGalleryBlocks() {
    let $elements = $('.js-image-gallery');
    $elements.each(function () {
        handleBlogGalleryBlock($(this));
    });
}

export function handleBlogGalleryBlock($element) {
    let gallery = new Gallery($element, {
        itemClass: "image-gallery__main-image",
        pipClass: "image-gallery__thumbnail",
        navigateClass: "js-navigate",
        pipsClass: "js-pips",
        itemsClass: "js-items",
        itemActiveModifier: "active",
        pipActiveModifier: "active",
        animationDuration: 0,
    });

    let gallery_track;
    let $gallery_track = $element.find(".js-image-gallery-wrap");


    if ($gallery_track.length > 0) {
        gallery_track = new Track($gallery_track, {
            classes: {
                block: "gallery",
            },
        });
    }

    let $track_items = $element.find(".js-track-item")
    let $track_button = $element.find(".js-track-navigation")

    if ($track_items.length <= 7) {
        $track_button.hide()
    }

    gallery.on('transitionStart', ({from, to}) => {
        // We need to ensure that the element is within the viewport
        updateTrackOffset(to, gallery, gallery_track);
    });

}

function updateTrackOffset(to = null, gallery = null, gallery_track = null) {

    if (gallery === null || gallery_track === null) {
        return;
    }

    if (to === null) {
        to = gallery.getActiveIndex();
    }
    let $to = gallery_track.getItems().eq(to);

    let offsetLeft = $to.position().left;
    let offsetRight = offsetLeft + $to.outerWidth();

    if (offsetLeft < gallery_track.getTransform()) {
        gallery_track.setTransform(offsetLeft - 4);
        return;
    }

    if (offsetRight > gallery_track.getTransform() + $('.js-image-gallery').innerWidth()) {
        gallery_track.setTransform(offsetRight - $('.js-image-gallery').innerWidth() + 4);
        return;
    }
}
